function set_initial_selected_campaign(instance) {
  if (!instance.selected_campaign_id) {
    instance.selected_campaign_id = instance.all_campaigns[0]?.id || null;
  }

  if (instance.donor_page > instance.donor_total_pages) {
    instance.donor_page = 1;
  }
}

function handle_campaign_load_results(instance, results) {
  const first_error = results.find((result) => result.status === "rejected");

  if (first_error) {
    instance.load_error_message = "Some campaign data could not be loaded.";
  }

  set_initial_selected_campaign(instance);
}

export const campaign_data_methods = {
  load_campaign_data() {
    this.load_error_message = "";

    const requests = [this.fetch_campaigns_api()];
    if (this.token_exists) {
      requests.push(this.fetch_my_campaigns_api());
    }

    Promise.allSettled(requests).then((results) => handle_campaign_load_results(this, results));
  },
  fetch_campaigns_api() {
    this.is_loading_public = true;
    return $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/get_campaigns/`,
      method: "GET",
      headers: this.get_request_headers(),
      success: (data) => {
        this.public_campaigns = data?.data || [];
      },
      complete: () => {
        this.is_loading_public = false;
      },
    });
  },
  fetch_my_campaigns_api() {
    if (!this.token_exists) {
      this.my_campaigns_data = [];
      return Promise.resolve();
    }

    this.is_loading_my_campaigns = true;
    return $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/get_my_campaigns/`,
      method: "GET",
      headers: this.get_request_headers(),
      success: (data) => {
        this.my_campaigns_data = data?.data || [];
      },
      complete: () => {
        this.is_loading_my_campaigns = false;
      },
    });
  },
};
